const paymentPl = {
    "billing": {
        "name": "Imię/Nazwa firmy",
        "country": "Kraj",
        "postal_code": "Kod pocztowy",
        "city": "Miasto",
        "address": "Adres",
        "tax_number": "Numer podatkowy",
        "phone": "Numer telefonu",
        "tax_number_helper_text": "Wymagane dla firm, nie jest wymagane dla osób fizycznych",
        "billing_info": "Informacje rozliczeniowe",
        "emails_helper_text": "Opcjonalnie. W przypadku wielu adresów e-mail rozdziel je przecinkami."
    },
    "subscription_plans": {
        "PRO": "Plan Pro",
        "FREE": "Bezpłatny plan"
    },
    "plan_descriptions": {
        "PRO": "Dla restauracji, które chcą przenieść swój biznes na wyższy poziom! Przetłumacz swoje menu na nowe języki za pomocą kilku kliknięć, zapytaj gości o opinie na temat ich dań, śledź wykorzystanie kodów QR w menu dzięki przydatnym statystykom lub pozwól, aby QuickPick AI automatycznie reagował na opinie gości w Twoim stylu!",
        "FREE": "Dla restauracji, które chcą zacząć korzystać z menu online i kodów QR."
    },
    "subscription_status": {
        "ACTIVE": "Aktywny",
        "CANCELLED": "Odwołany"
    },
    "next_billing_date": "Następna data rozliczenia",
    "current_subscription": "Aktualna subskrypcja",
    "cancel": "Anulować",
    "subscription_interval_prices": {
        "MONTHLY": "miesiąc",
        "YEARLY": "rok",
        "HALF_YEARLY": "pół roku",
        "QUARTERLY": "kwartał"
    },
    "subscription_interval_payment_name": {
        "MONTHLY": "Miesięczna subskrypcja",
        "YEARLY": "Roczna subskrypcja",
        "HALF_YEARLY": "Półroczna subskrypcja",
        "QUARTERLY": "Kwartalna subskrypcja"
    },
    "reactivate": "Reaktywować",
    "valid_to": "Ważne do",
    "payments_and_invoices": "Płatności i faktury",
    "amount": "Kwota",
    "invoice": "Faktura",
    "update_card": "Aktualizacja",
    "payment_method": "Metoda płatności",
    "cancel_subscription_confirmation": "Czy na pewno chcesz anulować obecną subskrypcję?",
    "cancel_subscription_valid_until": "Do czasu wygaśnięcia subskrypcji obowiązuje ona do dnia następującego",
    "subscription_cancelled": "Subskrypcja została pomyślnie anulowana",
    "reactivate_confirmation": "Czy na pewno chcesz reaktywować anulowaną subskrypcję?",
    "reactivate_successful": "Subskrypcja została pomyślnie reaktywowana",
    "change_payment_method": "Zmień metodę płatności",
    "change_payment_method_tooltip": "Aby zmienić dane płatności, musisz opłacić kolejny okres subskrypcji. Oczywiście, Twoja subskrypcja zostanie przedłużona o ten okres, a termin kolejnej płatności będzie taki sam.",
    "amount_to_be_paid": "Kwota do zapłaty",
    "new_subscription_valid_until": "Nowa ważność subskrypcji",
    "bank_card_expires_soon": "Karta bankowa użyta do opłacenia subskrypcji wkrótce straci ważność.",
    "reactivate_subscription_confirmation": "Czy na pewno chcesz reaktywować anulowaną subskrypcję?",
    "billing_information": "Informacje rozliczeniowe",
    "edit_billing_information": "Edytuj informacje rozliczeniowe",
    "no_available_invoices": "Brak dostępnych faktur",
    "subscribe": "Subskrybować",
    "continue_to_payment": "Przejdź do płatności",
    "confirm_subscription": "Potwierdź subskrypcję",
    "subscription_page_title": "Rozpocznij subskrypcję",
    "pay": "Zapłata",
    "available_plans": "Dostępna subskrypcja",
    "accept_terms_and_conditions": "Przeczytałem i akceptuję <a>Warunki i zasady</a>",
    "accept_recurring_payments": "Dokonując płatności akceptuję automatyczne pobieranie opłat cyklicznych, które mogę w każdej chwili anulować.",
    "accept_privacy_policy": "Przeczytałem i akceptuję <a>Politykę prywatności</a>",
    "subscribe_soon": "Już wkrótce"
};

export default paymentPl;
